import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BackToTop } from "@/components/BackToTop";
import { SocialLinks } from "@/components/SocialLinks";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import BlogDetail from "@/pages/BlogDetail";
import CertificationsPage from "@/pages/CertificationsPage";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App relative">
          <Navbar />
          <SocialLinks variant="floating" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/certifications" element={<CertificationsPage />} />
          </Routes>
          <Footer />
          <BackToTop />
          <WhatsAppFloat />
          <Toaster position="bottom-right" theme="dark" richColors closeButton />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
